// 모듈 불러오기
import React, { useEffect } from "react";
import styled from "styled-components";
import { Container } from "../../styles/Common";
import { ReactComponent as IcoBack } from "../../styles/images/ico_back.svg";
import { ReactComponent as Logo } from "../../styles/images/ico_logo.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// 컴포넌트 선언
const OnePageHeader = (props) => {
  const { isOpen, setOpen } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const changeUserNameSuccess = useSelector(
    (state) => state.user.changeUserNameSuccess
  );
  const changeUserPhoneSuccess = useSelector(
    (state) => state.user.changeUserPhoneSuccess
  );
  const path = location.pathname;
  const handleBackClick = () => {
    if (path == "/required/login") navigate(-2, { replace: true });
    else if (path == "/sign-up/terms-of-use") {
      navigate("/sign-up");
    } else if (path == "/mypage/edit/password") {
      sessionStorage.setItem(
        "page",
        JSON.stringify({ path: path, option: "password" })
      );
      navigate("/mypage/edit/", {
        state: { result: true, params: true },
      });
    } else if (
      (path == "/mypage/edit" && changeUserNameSuccess) ||
      (path == "/mypage/edit" && changeUserPhoneSuccess)
    ) {
      navigate(-4, { replace: true });
    } else {
      navigate(-1, {
        replace: true,
      });
    }
  };

  useEffect(() => {
    if (isOpen) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "unset";
  }, [isOpen]);

  return (
    <HeaderWrap>
      <Container>
        <header>
          <button onClick={handleBackClick}>
            <IcoBack />
          </button>
          <h2>
            {props.title == "logo" ? (
              <Logo
                onClick={() => {
                  navigate("/home");
                }}
              />
            ) : (
              props.title
            )}
          </h2>
          <div></div>
        </header>
      </Container>
    </HeaderWrap>
  );
};

// 스타일드 컴포넌트 선언
const HeaderWrap = styled.div`
  header {
    height: 6.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
    position: relative;
  }

  h2 {
    font-family: NanumSquareEB;
    font-size: 2rem;
    text-align: center;
    line-height: normal;
    color: ${({ theme }) => theme.color.purple_primary};
  }

  button {
    background-color: transparent;
    position: absolute;
    margin: auto;
    left: 2rem;
    top: 0;
    bottom: 0;
  }
`;

export default OnePageHeader;
